export default {

  buildId: (itemId, attachmentType, attachmentId) =>{
    let outputId = itemId?.toString() || ''
    if (typeof attachmentType !== "undefined" && attachmentType !== 'none') outputId += `:${attachmentType}`
    if (typeof attachmentId !== "undefined" && attachmentId !== null) outputId += `|${attachmentId}`
    return outputId
  }

}